import React from "react";
import "./roi.css";
import roiImage from "../../../images/Agent Trust Images/assets/ROI/roi-image.png";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import NumberDisplay from "../NumberDisplay";
export default function ROI() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.25 });

  const roiStats = [
    {
      value: 40,
      char: "%",
      h3: "Reduction in AI Security Vulnerabilities",
      p: "Proactive risk detection and mitigation help reduce vulnerabilities.",
    },
    {
      value: 30,
      char: "%",
      h3: "Decrease in Compliance Risks",
      p: "Automating regulatory adherence ensures data integrity and reduces risks.",
    },
    {
      value: 50,
      char: "%",
      h3: "Improvement in AI Model Transparency",
      p: "Trust scoring enhances explainability and fairness of AI models.",
    },
    {
      value: 35,
      char: "%",
      h3: "Faster AI Deployment Cycles",
      p: "Streamlined trust assessments reduce manual validation efforts, speeding up deployments.",
    },
  ];
  return (
    <section
      className={`roi-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="three"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>ROI</span>
          </div>

          <div className="heading-description">
            <h2>Maximize AI Reliability with Trust Scoring </h2>
            <p>
              Enhancing Security, Ensuring Compliance, and Strengthening AI
              Performance with AI Trust Score
            </p>
          </div>
        </div>

        <div className="roi-content-wrapper">
          <div className="roi-stats-cards row">
            {roiStats.map((item, index) => (
              <div className="roi-card" key={index}>
                <NumberDisplay
                  first={Math.max(item.value - 20, 0)}
                  last={item.value}
                  char={item.char}
                  isVisible={isVisible}
                />
                <h3>{item.h3}</h3>
                <p>{item.p}</p>
              </div>
            ))}
          </div>
          <div className="roi-image">
            <img src={roiImage} alt="roi-image" />
          </div>
        </div>
      </div>
    </section>
  );
}
